<template>
    <button type="button" class="btn btn-tool" :title="$t('labels.create')" @click="onClickFunction">
        <i class="fas fa-plus"></i>
    </button>
</template>

<script>
export default {
    name: "TheCreateButton",
    props: {
        onClickParent: {
            type: Function,
            default: () => {}, // Đảm bảo luôn có giá trị mặc định
        },
    },
    methods: {
        onClickFunction() {
            // Gọi hàm được truyền từ Parent
            this.onClickParent();
        },
    },
};
</script>

<style></style>
